module.exports = __webpack_public_path__ + "static/media/videoPreview3.164bbbda.mp4";